import React from 'react';
import Link from '../../../../lib/components/link';
import { Grid } from 'semantic-ui-react';
import styles from './DesktopFooter.styles';

const DesktopFooterLinks = ({ menu }) =>
  (<Grid style={styles.linkGrid}>
    <Grid.Row>
      {menu && menu.length
        ? menu.map( col =>
            <Grid.Column
              key={col.key}
              width={4}
              style={styles.footerLinksColumn}
            >
              {col.children && col.children.length
                ? col.children.map(item =>
                    <div
                      key={item.key}
                      style={styles.footerLinkText}
                    >
                      <Link
                        style={styles.footerLinkText}
                        {...item}
                      >
                        {item.label}
                      </Link>
                    </div>
                  )
                : <div>Loading</div>}
            </Grid.Column>
          )
        : <div>Loading</div>}
    </Grid.Row>
  </Grid>);

export default DesktopFooterLinks;



// WEBPACK FOOTER //
// ./src/app/components/Footer/DesktopFooter/DesktopFooterLinks.js